import { render, staticRenderFns } from "./headings.vue?vue&type=template&id=002e0fe8&"
import script from "./headings.vue?vue&type=script&lang=js&"
export * from "./headings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports